<template>
<section class="section footer">

  <div class="footer__content">
    <div class="footer_logo">
      <p class="logo">VANIPLATE</p>
      <p class="sublogo">© «VANIPLATE». All rights reverved. 2019-2021</p>
    </div>

    <div class="content__menu">
      <div class="menu__block">
        <p class="block_title">Service</p>
        <router-link to="/">Home</router-link>
        <router-link to='/vanidea'>My vanidea</router-link>
        <router-link to="/insurance">Insurance</router-link>
        <a href="/blog" >Blog</a>
      </div>

      <div class="menu__block">
        <p class="block_title">Custom vanity</p>
        <router-link :to="`/${state}`" 
                     v-for="(state, index) in filter_state" 
                     :key="index"
                     target="_blank">
                     {{ capitalize(state) }}
                     </router-link>
        <button class="btn" v-if="!show_all" @click="show_all = true">Show all</button>
        <button class="btn" v-if="show_all" @click="show_all = false">Collapse</button>
      </div>

      <div class="menu__block">
        <p class="block_title">Information</p>
        <router-link to="/contact">Contacts</router-link>
        <router-link to='/about'>About us</router-link>
      </div>



      <div class="menu__block">
        <p class="block_title">Documents</p>
        <router-link to="/terms">Terms and conditions</router-link>
        <router-link to='/disclaimer'>Disclaimer</router-link>
        <router-link to='/privacy'>Privacy Policy</router-link>
      </div>
    </div>
  </div>

  <div class="footer__inc">
    <p class="inc">We use cookies to collect depersonalized personal data. They help you set up ads and analyze traffic. By remaining on the site, you consent to the collection of such data.</p>
  </div>
</section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "Footer",

  data() {
    return {
      show_all: false
    }
  },

  computed: {
    ...mapState(['links', 'states']),
    
    filter_state() {
      if (this.show_all) {
        return this.states
      }
      return this.states.slice(0, 5)
    }
  },

  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.substring(1);
    },
  }
}
</script>


<style lang="sass" scoped>
@import "@/assets/sass/home.sass"
</style>